






























import { Component, Prop, Vue } from "vue-property-decorator";
import { logService } from '@/services/LogService';
import { eventService } from "@/services/EventService";
import { Usuario } from '@/model/Usuario';

@Component({
  components: {}
})
export default class UsuarioPopup extends Vue {
  
  usuario: any | Usuario;

  nombre: string ="";

  login: string ="";

  password: string ="";

  passwordConfirmacion: string ="";

  rol: string ="Normal";
  valid: boolean = false;

  campoRequerido: string = 'Campo requerido'

  usuarioRules: any = [
    (v: any) => !!v || this.campoRequerido,
    (v: any) => (v && v.length >= 6) || 'El usuario debe tener más de 6 caracteres.'
  ]

  nombreRules: any = [(v: any) => !!v || 'Campo requerido']

  passwordRules: any = [(v: any) => !!v || 'Campo requerido',
    (v: any) => (v && v.length >= 6) || 'El password debe tener más de 6 caracteres.']
  
  passwordConfirmacionRules: any = [(v: any) => !!v || 'Campo requerido',
    (v: any) => (v && this.checkPassword(v)) || 'Debe coincidir con la contraseña.']

  checkPassword(v: any ){
    return v === this.password;
  }

  destroyed(){
    eventService.off("UsuarioPopup-Open");
    eventService.off("DialogForm-Save");
  }

  created() {
    logService.Info("Inicio","UsuarioPopup.vue - created()");
    eventService.on("UsuarioPopup-Open", (obj: any) => {
      this.usuario = obj;
      if(obj.Nombre !== ""){
        this.nombre = this.usuario.Nombre;
        this.login = this.usuario.Login;
        this.password = this.usuario.Password;
        this.passwordConfirmacion = this.usuario.Password;
        this.rol = this.usuario.Rol === 0 ? 'Normal' : 'Administrador';
      }
    });

    eventService.on("DialogForm-Save", (obj: any) => {
      if ((<any>this.$refs.formUsuario).validate()) {
        this.usuario.Nombre = this.nombre;
        this.usuario.Login = this.login;
        this.usuario.Password = this.password;
        this.usuario.Rol = this.rol === 'Normal' ? 0 : 99;
        eventService.emit('UsuarioPopup-Save',this.usuario)

        this.nombre = "";
        this.login = "";
        this.password ="";
        this.passwordConfirmacion ="";
        this.rol = "Normal";
        this.usuario = null;
        this.valid = true;
        (<any>this.$refs.formUsuario).reset()
      }
    });
  }
}
